// Delivery Moment Component
// This is the block that renders on the top of the PLP pages, that shows the delivery moment information


import { Component } from '@theme/component';

export class DeliveryMomentComponent extends Component {
  connectedCallback() {
    try {
      super.connectedCallback();
    } catch (error) {
      throw error;
    }
  }

  disconnectedCallback() {
    try {
      super.disconnectedCallback();
    } catch (error) {
      throw error;
    }
  }

  /** @param {Event} event */
  editLocation(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
      
      // Use the existing function from delivery-core.js
      if (/** @type {any} */ (window).DeliveryCore?.openPostalCodeDrawer) {
        /** @type {any} */ (window).DeliveryCore.openPostalCodeDrawer();
      } else {
        // Log warning if function is not available
        // console.warn('[DELIVERY-MOMENT] DeliveryCore.openPostalCodeDrawer not available');
      }
    } catch (error) {
      throw error;
    }
  }

  /** @param {Event} event */
  editTime(event) {
    try {
      event.preventDefault();
      event.stopPropagation();
      
      // Use the existing function from delivery-core.js
      if (/** @type {any} */ (window).DeliveryCore?.openDeliveryTimesDrawer) {
        /** @type {any} */ (window).DeliveryCore.openDeliveryTimesDrawer();
      } else {
        // Log warning if function is not available
        // console.warn('[DELIVERY-MOMENT] DeliveryCore.openDeliveryTimesDrawer not available');
      }
    } catch (error) {
      throw error;
    }
  }
}

if (!customElements.get('delivery-moment-component')) {
  customElements.define('delivery-moment-component', DeliveryMomentComponent);
}
